import { render } from "./ItemLabel.vue?vue&type=template&id=5f916c06&scoped=true"
import script from "./ItemLabel.vue?vue&type=script&lang=js"
export * from "./ItemLabel.vue?vue&type=script&lang=js"

import "./ItemLabel.vue?vue&type=style&index=0&id=5f916c06&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f916c06"]])

export default __exports__